import mapperIcon from '#layers/core/data-layer/utils/mappers/mapper-icon'
import type { MapperOptions } from '~/types'

/**
 * Page Uplift mapper
 * normalizes data to be used in pages
 */

export const mapperPageUpliftDetail = (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  const linkUrl = options.getInternalUrl ? options.getInternalUrl(data?.sys?.id) : ''

  return {
    title: data.title || '',
    slug: data.slug || '',
    url: linkUrl || '',
    productName: data.productName || '',
    productIcon: mapperIcon(data?.productIcon),
    description: data?.hero?.description || null
  }
}
